import { GET_PRESIGNED_URL } from '../graphql/resolvers/helperResolvers/getPresignedUrl';
import { apolloClient } from './apolloClient';

/**
 * TRIL-523: upload a post image via the canonical presigned-URL flow.
 *
 * Was an unimplemented stub returning '' — which broke post image uploads and (via the empty url)
 * flooded the console through extractS3Key. Now: ask the server for a presigned PUT
 * (getPresignedUrl mutation → POST_MEDIA_BUCKET), PUT the file straight to S3, and return the
 * public imageUrl the server constructs (an absolute S3 URL extractS3Key understands).
 *
 * The caller (BlockTypesRender.handleImageUpload) has already validated file type + size.
 * @returns the uploaded image's public URL.
 */
export async function uploadImage(file: File): Promise<string> {
  const { data } = await apolloClient.mutate({
    mutation: GET_PRESIGNED_URL,
    variables: { fileType: file.type, fileSize: file.size },
  });

  const presigned = data?.getPresignedUrl;
  if (!presigned?.presignedUrl || !presigned?.imageUrl) {
    throw new Error('Failed to get a presigned upload URL');
  }

  // PUT the file straight to S3. Content-Type MUST match what the URL was signed with (file.type),
  // or S3 rejects the signature.
  const res = await fetch(presigned.presignedUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
  });
  if (!res.ok) {
    throw new Error(`Image upload failed (${res.status})`);
  }

  return presigned.imageUrl as string;
}
